/**
 * Created by weihuang on 2017/11/2.
 */
import axios from 'axios';

//sign_in
export const requestLogin = params => {
  return axios.post(`${ymj_root}admins/register/sign_in`, params);
};
//sign_out
export const requestLogout = () => {
  return axios.post(`${ymj_root}admins/sessions/sign_out`)
    .then(res => res.data)
    .catch(error => {
      const { response } = error;
      if (response) {
        return { status: 1, status_text: `请求发生错误，http状态码：${response.status}`}
      }
      return { status: 1, status_text: '请求发生未知错误'};
    });
};
//get token
export const getRequestToken = params => {
  return axios.get(`${ymj_root}admins/commons/get_csrf_meta.json`, { params: params }).then(res => res.data);
};
//reset pwd
export const patchResetPassword = params => {
  return axios.post(`${ymj_root}admins/register/change_password`, params);
};
//get contract users list
export const getContractUsersList = params => {
  return axios.get(`${ymj_root}admins/contract_users`, { params: params }).then(res => res.data);
};
//get contract list
export const getContractList = params => {
  return axios.get(`${ymj_root}admins/contracts`, { params: params }).then(res => res.data);
};
//get company list
export const getCompanyList = params => {
  return axios.get(`${ymj_root}admins/companys`, { params: params }).then(res => res.data);
};
//get bus_change_logs
export const RepaymentChange = params => {
  return axios.get(`${ymj_root}admins/bus_bill_change_logs/search`, { params: params }).then(res => res.data);
};
//get bus_installments
export const BusInstallment = params => {
  return axios.get(`${ymj_root}admins/bus_installments/search`, { params: params }).then(res => res.data);
};
//get bus_interest_transfer_logs
export const BusInterestTransferLog = params => {
  return axios.get(`${ymj_root}admins/bus_interest_transfer_logs/search`, { params: params }).then(res => res.data);
};
//get bus_tradings
export const BusTradingResult = params => {
  return axios.get(`${ymj_root}admins/bus_tradings/search_result`, { params: params }).then(res => res.data);
};

export const getRepaymentList = params => {
  return axios.get(`${ymj_root}admins/bus_offline_pay_log`, { params: params }).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/api.js